export const GOOGLE_ADS_ID = "AW-862081749";
export const GOOGLE_ADS_SIGNUP_DESTINATION = `${GOOGLE_ADS_ID}/EpMTCPafhvocENWliZsD`;
export const GOOGLE_ADS_CONSENT_COOKIE = "iloris_google_ads_consent";
export const GOOGLE_ADS_OPEN_SETTINGS_EVENT = "iloris:open-ad-measurement-settings";
export const GOOGLE_ADS_SIGNUP_COOKIE = "iloris_google_ads_signup";
export const GOOGLE_ADS_SIGNUP_TTL = 30 * 24 * 60 * 60;

export function googleAdsEnabled() {
    return process.env.NEXT_PUBLIC_GOOGLE_ADS_ENABLED === "true";
}
